import { Grid, Typography } from "@mui/material";
import * as React from "react";
import Chart from "react-apexcharts";

export default class RadarCopertura extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      series: [
        {
          name: "",
          data: [
            props.data.filter((a) => a.copertura === "Non Coperta").length,
            props.data.filter((a) => a.copertura === "Più scoperta che coperta")
              .length,
            props.data.filter((a) => a.copertura === "Parzialmente coperta")
              .length,
            props.data.filter((a) => a.copertura === "Più coperta che scoperta")
              .length,
            props.data.filter((a) => a.copertura === "Coperta").length,
          ],
        },
      ],
      options: {
        labels: [
          "Non Coperta",
          "Più scoperta che coperta",
          "Parzialmente coperta",
          "Più coperta che scoperta",
          "Coperta",
        ],
        chart: {
          width: 380,
          type: "radar",
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          radar: {
            size: 140,
            polygons: {
              strokeColors: "#e9e9e9",
              fill: {
                colors: ["#f8f8f8", "#fff"],
              },
            },
            offsetY: 15,
          },
        },
        colors: ["#335571"],
        markers: {
          size: 4,
          colors: ["#fff"],
          strokeColor: "#335571",
          strokeWidth: 2,
        },
        tooltip: {},
        yaxis: {
          tickAmount: 7,
          labels: {
            formatter: function (val, i) {
              if (i % 2 === 0) {
                return "";
              } else {
                return "";
              }
            },
          },
        },
        dataLabels: {
          enabled: true,
        },
        legend: {
          show: false,
        },
      },
    };
  }

  render() {
    return !this.props.report ? (
      <Grid
        item
        xs={12}
        md={6}
        container
        justifyContent={"center"}
        flexWrap={"wrap"}
      >
        <Grid item xs={12} md={12}>
          <Typography
            sx={{
              fontWeight: "600",
              textAlign: "center",
              marginBottom: "8px !important",
              fontSize: "15px",
              color: "#033661",
            }}
            component={"p"}
          >
            Copertura
          </Typography>
        </Grid>
        <Chart
          options={this.state.options}
          series={this.state.series}
          type="radar"
          height={320}
          width={600}
        />
      </Grid>
    ) : (
      <Grid
        sx={{ transform: "scale(0.75)", transformOrigin: "center" }}
        justifyContent={"center"}
        flexWrap={"wrap"}
        item
        xs={6}
        md={6}
      >
        <Chart
          options={this.state.options}
          series={this.state.series}
          type="radar"
          height={290}
          width={386}
        />
      </Grid>
    );
  }
}
